import {
  setEmail,
  setFlow,
  setIntent,
  setPhone,
} from 'src/pages/scheduleCallback/store/actions/app';
import {cancelAppointmentStep} from 'src/pages/scheduleCallback/store/actions/cancelAppointmentStep';
import {errorStep} from 'src/pages/scheduleCallback/store/actions/errorStep';
import {
  LOAD_INTERACTIONS_COMPLETE,
  loadInteractions,
} from 'src/pages/scheduleCallback/store/actions/interactions';
import {outageDetectedStep} from 'src/pages/scheduleCallback/store/actions/outageDetectedStep';
import {selectIntentStep} from 'src/pages/scheduleCallback/store/actions/selectIntentStep';
import {selectTimeslotStep} from 'src/pages/scheduleCallback/store/actions/selectTimeslotStep';
import {
  email,
  hasAppointment,
  intent,
  phone,
} from 'src/pages/scheduleCallback/store/selectors/app';
import {
  READ_ACCOUNT_COMPLETE,
  readAccount,
} from 'src/shared/account/actions';
import {
  preferredEmail,
  primaryPhone,
} from 'src/shared/account/selectors';
import {
  AUTH,
  authenticate,
} from 'src/shared/auth/actions';
import {isAuthenticated} from 'src/shared/auth/selectors';
import {changeView} from 'src/shared/currentView/actions';
import {LOADING} from 'src/shared/currentView/commonViews';
import {datacast} from 'src/shared/datacast/actions';
import {
  hasOutageMessagesSegment,
  hasProactiveIssueDetectionSegment,
} from 'src/shared/datacast/selectors';
import {startDataLayerTracking} from 'src/shared/dataLayer/actions';
import {
  waitUntil,
  waitUntilOneOf,
} from 'src/shared/events';
import {preloadItgRecommendations} from 'src/shared/itgRecommendations/actions';
import {
  LOAD_OUTAGES_COMPLETE,
  LOAD_OUTAGE_CONSOLIDATED_COMPLETE,
  loadOutageConsolidated,
  loadOutages,
} from 'src/shared/outages/actions';
import {
  currentOutage,
  outageImpact,
  outageConsolidated,
  outages,
} from 'src/shared/outages/selectors';
import {contactUs} from 'src/shared/pagePaths';
import {combined} from 'src/shared/params/selectors';
import {setRedirectUrl} from 'src/shared/redirect/actions';
import {resourceStatus} from 'src/shared/resourceStatus/selectors';
import {loadUser} from 'src/shared/user/actions';
import {HIGH} from 'src/shared/outages/constants';

export const startFlow = () => async (dispatch, getState) => {
  dispatch(changeView(LOADING));

  dispatch(authenticate({requiresAuthentication: true}));
  await waitUntil(AUTH);
  if (!isAuthenticated(getState())) {
    return;
  }

  dispatch(loadUser());
  dispatch(datacast()).then(() => {
    if (hasProactiveIssueDetectionSegment(getState())) {
      dispatch(preloadItgRecommendations());
    }
    if (hasOutageMessagesSegment(getState())) {
      dispatch(loadOutageConsolidated());
    } else {
      dispatch(loadOutages());
    }
  });
  dispatch(startDataLayerTracking());
  dispatch(readAccount()).then(() => {
    if (!phone(getState())) {
      dispatch(setPhone(primaryPhone(getState())));
    }
    if (!email(getState())) {
      dispatch(setEmail(preferredEmail(getState())));
    }
  });
  dispatch(loadInteractions());
  dispatch(setRedirectUrl(contactUs()));

  dispatch(setIntent(intent(getState())));
  const {flow} = combined(getState());
  if (flow) {
    dispatch(setFlow(flow));
  }

  await waitUntilOneOf(LOAD_OUTAGES_COMPLETE, LOAD_OUTAGE_CONSOLIDATED_COMPLETE);

  if (hasOutageMessagesSegment(getState())) {
    if (outageImpact(getState()) === HIGH && flow !== 'ENROLL_SMS') {
      return dispatch(outageDetectedStep(outageConsolidated(getState())));
    }
  } else {
    if (currentOutage(getState()) && flow !== 'ENROLL_SMS') {
      return dispatch(outageDetectedStep(outages(getState())));
    }
  }

  await waitUntil(LOAD_INTERACTIONS_COMPLETE);
  if (resourceStatus(getState()).error.interactions) {
    return dispatch(errorStep());
  }

  if (hasAppointment(getState())) {
    return dispatch(cancelAppointmentStep());
  }

  await waitUntil(READ_ACCOUNT_COMPLETE);
  if (intent(getState())) {
    return dispatch(selectTimeslotStep());
  }
  return dispatch(selectIntentStep());
};
